export default "__VITE_ASSET__Bxu19$k5__"